import { memo } from 'react';
import { Typography } from 'antd';
import { Auction } from 'models/auction/Auction';

import AuctionProductTag from './AuctionProductTag';

const { Title } = Typography;

interface AuctionTitleProps {
  auction: Auction;
}

function AuctionTitle({ auction }: AuctionTitleProps) {
  const { title, condition } = auction;

  return (
    <Title>
      <AuctionProductTag condition={condition} style={{ fontSize: '0.6em', verticalAlign: 'middle' }} />
      {title}
    </Title>
  );
}

export default memo(AuctionTitle);
